import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import useAuth from 'src/hooks/useAuth';
import { useNavigatorOnLine } from 'src/hooks/useNavigatorOnline';
import useSocket from 'src/hooks/useSocket';
type Props = { children?: React.ReactNode };
const NetworkHandler: React.FC<Props>  = ({ children }) => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const { activeConnection } = useSocket();
  const [isReconnecting, setIsReconnecting] = useState(false);
  const isOnline = useNavigatorOnLine();
  const retryingSnackbarKey = 'retryingSnackbar';
  const offlineSnackbarKey = 'offlineSnackbar';
  const { isAuthenticated } = useAuth();
 
  if(activeConnection){
    activeConnection.onreconnecting(() => {
      setIsReconnecting(true);
    });

    activeConnection.onreconnected(() => {
      setIsReconnecting(false);
    });
  }

  useEffect(() => {
    const message = `No connection. ${isReconnecting ? 'Trying to reconnect...' : ''}`;
    if (!isOnline && isReconnecting) {
      enqueueSnackbar(message, { variant: 'warning', persist: true, key: retryingSnackbarKey, preventDuplicate: true, });
      closeSnackbar(offlineSnackbarKey);
    } else if (!isOnline) {
      enqueueSnackbar(message, { variant: 'warning', persist: true, key: offlineSnackbarKey, preventDuplicate: true, });
      closeSnackbar(retryingSnackbarKey);
      if(!isAuthenticated){
        setTimeout(() => {
          setIsReconnecting(true);
        }, 10000);
      }
    } else {
      closeSnackbar(offlineSnackbarKey);
      closeSnackbar(retryingSnackbarKey);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOnline, isReconnecting, retryingSnackbarKey, offlineSnackbarKey]);

  return (
    <>
      {children}
    </>
  );
};

export default NetworkHandler;
